import React, { forwardRef } from 'react';
import { ArrowRightIcon as ArrowIcon } from '../../../../assets/icons/index';
import CSS from './DropdownBtn.module.scss';

interface IParentProps {
	style?: React.CSSProperties;
	icon?: React.FunctionComponent;
	open: boolean;
	text: string;
	disabled?: boolean;
	onClick: () => unknown;
	testId?: string;
	rhsText?: string;
}

const DropdownBtn = forwardRef<HTMLDivElement, IParentProps>(({ style = {}, open, icon: Icon, text, disabled, onClick, rhsText, testId = 'DropdownBtn' }, ref) => {
	return (
		<div
			data-testid={testId}
			className={`${CSS.DropDown} ${open && CSS.Active} ${disabled && CSS.Disabled}`}
			onClick={() => {
				if (!disabled) onClick();
			}}
			style={{ ...style }}
			ref={ref}
		>
			<div className={CSS.SelectedOptionContainer}>
				{Icon && <Icon />}
				<span className={CSS.Text} title={text}>
					{text}
				</span>
			</div>
			{!!rhsText ? (
				<div className={CSS.RightSideDiv}>
					{rhsText}
					<ArrowIcon viewBox={[0, 0, 7, 7]} className={`${CSS.Arrow} ${open && CSS.RotatedArrow}`} />
				</div>
			) : (
				<ArrowIcon viewBox={[0, 0, 7, 7]} className={`${CSS.Arrow} ${open && CSS.RotatedArrow}`} />
			)}
		</div>
	);
});

DropdownBtn.displayName = 'Dropdown Button';
export default DropdownBtn;
